import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TegelModule } from '@scania/tegel-angular-17';
import { DeskPopoverComponent } from '../../desk-popover/desk-popover.component';
import { ReservationListComponent } from '../../reservation-list/reservation-list.component';
import { BuildingAdminComponent } from '../../../admin/building-admin/building-admin.component';
import { P35_DESKS } from '../shared/constants/p35.desks';
import { BuildingReservationsBase } from '../shared/reservation-base';

@Component({
  selector: 'app-p35',
  imports: [ReservationListComponent, TegelModule, DeskPopoverComponent, BuildingAdminComponent, CommonModule],
  templateUrl: './p35.component.html',
  styleUrl: './p35.component.scss'
})
export class P35Component extends BuildingReservationsBase {
  public readonly desks = P35_DESKS;
}